import TypeaheadUtils from "./typeahead_utils";
const Grid_Utils = {
    dummyKey: "dummyGridKey",
    passwordMask: "******",
    oldGridData: {},
    collapsedIndexes: [],
    renderEditableGrid(dataJson) {
        var self = this;
        window.dataAsJsonForGrid = [];
        this.oldGridData = {};
        // Temporary attach
        $('table[dataSource]').attr("data-grid", 'true');
        $('table[dataSource]').attr("data-datasource",
            $('table[dataSource]').attr("dataSource"));
        if (typeof dataJson == "string") {
            dataJson = JSON.parse(dataJson);
        }

        if ($.isEmptyObject(dataJson)) {
            dataJson = self.generateEmptyDataJson();
        }

        $("div[name='grid-data']").remove();
        $("[data-grid='true']").each(function () {
            let form = $('#editGridPopup form');
            let defaultFormData = [];
            storeFormDefaultState(defaultFormData, form);
            self.updateNameInDataByDatafield(defaultFormData, form);
            $('#editGridPopup #dataDiv').data("defaultForm", defaultFormData);
            self.splitDataSourceAndPopulateRowForGrid(this, dataJson)
        });
    },
    generateEmptyDataJson() {
        var dataJson = {};
        $("[data-grid='true']").each(function () {
            let dataSource = $(this).attr('data-datasource');
            dataSource.split(".").reverse().forEach(function (key) {
                if ($.isEmptyObject(dataJson)) {
                    dataJson[key] = [];
                }
                else {
                    var newJson = {};
                    newJson[key] = dataJson;
                    dataJson = newJson;
                }
            });
        });
        return dataJson;
    },
    splitJsonKey(jsonKeyRef) {
        var newJsonKey = "";
        for (var ref = 0; ref < jsonKeyRef.length; ref++) {
            if (ref == 0) {
                newJsonKey = jsonKeyRef[0];
            } else if (jsonKeyRef[ref].indexOf("-") != -1) {
                if (jsonKeyRef[ref].indexOf("[") != -1) {
                    newJsonKey = newJsonKey + "['" + jsonKeyRef[ref].split("[")[0]
                        + "']" + "[" + jsonKeyRef[ref].split("[")[1];
                } else {
                    newJsonKey = newJsonKey + "['" + jsonKeyRef[ref] + "']";
                }
            } else {
                newJsonKey = newJsonKey + "." + jsonKeyRef[ref];
            }
        }
        return newJsonKey;
    },
    remove(obj, key) {
        let objAssign = {};
        objAssign[key] = obj[key];
        return $.extend({}, {}, objAssign);
    },
    createObject(object, path, value) {
        var keys = path.split('.'), last = keys.pop();
        keys.reduce(function (o, k) {
            return o[k] = o[k] || {};
        }, object)[last] = value;
    },
    splitDataSourceAndPopulateRowForGrid(eleObj, dataJson) {
        let dataSource = $(eleObj).attr('data-datasource');
        let dataSourceOriginal = dataSource;
        let dataSourceArr = dataSource.split(".");

        if (dataSourceArr.length == 1) {
            dataSourceArr.splice(0, 0, this.dummyKey);
            $(eleObj).attr('data-datasource', this.dummyKey + "." + dataSource);
            dataSource = this.dummyKey + "." + dataSource;
        }

        if (dataJson == null) {
            dataJson = {};
        }
        var jsonData = {};

        if (!dataJson.hasOwnProperty(dataSourceArr[0])) {
            jsonData[dataSourceArr[0]] = dataJson;
            dataJson = jsonData;
        }
        if (!$.isEmptyObject(dataJson)) {
            let oldJsonObj = JSON.parse(JSON.stringify(dataJson[dataSourceArr[0]]));
            let tempObj = JSON.parse(JSON.stringify(oldJsonObj))
            this.oldGridData = {};
            for (let i = 1; i < dataSourceArr.length; i++) {
                tempObj = this.remove(tempObj, dataSourceArr[i]);
                tempObj = tempObj[dataSourceArr[i]];
            }
            this.createObject(this.oldGridData, dataSourceOriginal, tempObj);
        }
        window.initGridDialog($(eleObj));
        setTimeout(() => {
            this.populateRepeatableRowForGrid(dataSource, dataSourceArr[dataSourceArr.length - 1], dataJson, eleObj);
            setTimeout(() => {
                this.bindAddDeleteEventsForGrid();
                window.bindClickOnGridCollapse();

                if ($('.add-row-grid').length > 0 && $("#oldGridRow").length == 0
                    && this.oldGridData != null && !$.isEmptyObject(this.oldGridData)) {
                    var input = $("<input>").attr("type", "hidden").attr("name",
                        'oldGridRow').attr("id", 'oldGridRow').attr(
                            "value", JSON.stringify(this.oldGridData));
                    $('#render-canvas').append($(input));
                }
            }, 100);
        }, 0);
    },

    initGridDialog(tableObj) {
        let gridName = $(tableObj).attr('datasource');
        let dataLiEle = $('#editGridPopup #dataDiv');
        dataLiEle.html('');
        let jsonObj = $("#editGridPopup").data('renderJSON');
        window.getPreview(jsonObj[gridName], dataLiEle, 0);
        window.bindExpressions();
    },

    bindSaveHandler() {
        var self = this;
        $('#editGridPopup #saveGridBtn').off("click");
        $('#editGridPopup #saveGridBtn').on("click", function (e) {
            self.saveEditGridIntegrated(e)
        });
    },

    addGridRowBtnHandler(addBtn) {
        let tableObj = $(addBtn).prev('table[dataSource]');
        let parentTR = $(tableObj).children('tbody').children('tr').eq(0);
        $('#editGridPopup').data('activeRow', parentTR);
        $('#editGridPopup').data('activeTable', tableObj);
        let gridName = $(tableObj).attr('datasource');
        let dataLiEle = $('#editGridPopup #dataDiv');
        dataLiEle.html('');
        let jsonObj = $("#editGridPopup").data('renderJSON');
        window.getPreview(jsonObj[gridName], dataLiEle, 0);
        window.bindMultiSelectDropdownIntegrated(false);
        setTimeout(() => {
            //TypeaheadUtils.updateTypeAheadData();
            window.bindExpressions();
            dataLiEle = $('#editGridPopup form');
            window.showDialog('editGridPopup');
            $('#closeEditGridForm').removeClass("ms-was-validated");
            $("#grid-popup-wait").removeClass("d-none");
            TypeaheadUtils.updateDynamicTypeAheadData().then(() => {
                $("#grid-popup-wait").addClass("d-none");
            });
            $('#editGridPopup .mcc-dialog__header .h4').html('Add Row');
            $('#editGridPopup #activeIndex').attr('value', "-1");
            $('#editGridPopup #mode').attr('value', "add");
            var formData = $('#editGridPopup #dataDiv').data('form');
            formData = (formData !== undefined && formData.hasOwnProperty(gridName)) ?
                formData[gridName] : undefined;
            if (formData === undefined || formData.length === 0) {
                // Initially load the data
                let form = $('#editGridPopup form');
                let defaultFormData = [];
                window.storeFormDefaultState(defaultFormData, form);
                let obj = {};
                obj[gridName] = defaultFormData;
                $('#editGridPopup #dataDiv').data("form", obj);
                formData = defaultFormData;
            }
            $(dataLiEle)[0].reset();
            window.updateValueInElements(formData, $('#editGridPopup'));
            window.bindDatePickerIntegrated(false);
        }, 0)
    },
    setCollapseStateChildGrids() {
        var self = this;
        self.collapsedIndexes = [];
        $(".subGridRow").each((i, element) => {
            self.collapsedIndexes[i] = !$(element).hasClass('d-none');
        })
    },
    updateCollapseStateChildGrids() {
        var self = this;
        $(".subGridRow").each((i, element) => {
            if (self.collapsedIndexes[i]) {
                $(element).removeClass('d-none')
            }
        })
    },

    bindAddDeleteEventsForGrid() {
        var self = this;
        $('.add-row-grid').unbind('click');
        $('.deleteBtn').unbind('click');
        $('.editBtn').unbind('click');
        $('.copyBtn').unbind('click');
        this.bindSaveHandler();

        $(".add-row-grid").click(function () {
            self.addGridRowBtnHandler($(this));
        });

        $(".copyBtn").click(function () {
            var parentRowObj = $(this).closest("tr");
            $('#editGridPopup').data('activeRow', parentRowObj);
            var jsonObjKey = parentRowObj.attr("newname");
            let tableObj = $(this).closest('table');
            let trCount = $(tableObj).children('tbody').children('tr.form-content-tr').length
            var dataSrc = self.getDatasource(tableObj);
            if (dataSrc.indexOf(self.dummyKey) != -1) {
                jsonObjKey = self.dummyKey + "." + jsonObjKey;
            }

            if (self.isChildGrid(tableObj)) {
                jsonObjKey = self.getJSONKey(tableObj);
            }
            else {
                jsonObjKey = self.splitJsonKey(jsonObjKey.split("."));
            }
            let val = JSON.stringify(self.getGridObj(window.dataAsJsonForGrid[dataSrc], jsonObjKey));
            let len = jsonObjKey.lastIndexOf("]") - jsonObjKey.lastIndexOf("[");
            let updatedJsonObjKey = jsonObjKey.substring(0, jsonObjKey.length- (len+1));
            let updatedPath = self.addPathForGrid(window.dataAsJsonForGrid[dataSrc],updatedJsonObjKey,trCount+1,val)
            let rootGrid = self.isChildGrid(tableObj) ? $(tableObj).closest('[data-grid="true"]') : $(tableObj)
            if (self.isChildGrid(tableObj)) {
                self.setCollapseStateChildGrids();
            }
            $("div[name='grid-data']").remove();
            $("[data-grid='true']").each(function () {
                let form = $('#editGridPopup form');
                let defaultFormData = [];
                storeFormDefaultState(defaultFormData, form);
                self.updateNameInDataByDatafield(defaultFormData, form);
                $('#editGridPopup #dataDiv').data("defaultForm", defaultFormData);
            });
            self.splitDataSourceAndPopulateRowForGrid($(rootGrid), window.dataAsJsonForGrid[dataSrc]);
            setTimeout(() => {
                self.updateCollapseStateChildGrids();
                window.bindSummaryOperations();
            }, 250);
            self.setCollapseStateChildGrids();
        });

        $(".deleteBtn").click(function () {
            var parentRowObj = $(this).closest("tr");
            $('#editGridPopup').data('activeRow', parentRowObj);
            var jsonObjKey = parentRowObj.attr("newname");
            let tableObj = $(this).closest('table');
            var dataSrc = self.getDatasource(tableObj);
            if (dataSrc.indexOf(self.dummyKey) != -1) {
                jsonObjKey = self.dummyKey + "." + jsonObjKey;
            }

            if (self.isChildGrid(tableObj)) {
                jsonObjKey = self.getJSONKey(tableObj);
            }
            else {
                jsonObjKey = self.splitJsonKey(jsonObjKey.split("."));
            }

            self.pathForGrid(window.dataAsJsonForGrid[dataSrc], jsonObjKey);
            let rootGrid = self.isChildGrid(tableObj) ? $(tableObj).closest('[data-grid="true"]') : $(tableObj)
            if (self.isChildGrid(tableObj)) {
                self.setCollapseStateChildGrids();
            }
            self.splitDataSourceAndPopulateRowForGrid($(rootGrid), window.dataAsJsonForGrid[dataSrc]);
            setTimeout(() => {
                self.updateCollapseStateChildGrids();
                window.bindSummaryOperations();
            }, 500);
        });

        $(".editBtn").click(function () {
            var activeIndex = $(this).closest('td').parent()[0].sectionRowIndex;
            self.initGridDialog($(this).closest('table'));
            window.bindMultiSelectDropdownIntegrated(false);
            $('#editGridPopup #activeIndex').attr('value', activeIndex);
            $('#editGridPopup #mode').attr('value', "edit");
            let parentTR = $(this).closest('tr')
            window.showDialog('editGridPopup');
            $('#closeEditGridForm').removeClass("ms-was-validated");
            $('#editGridPopup .mcc-dialog__header .h4').html('Edit Row');
            $('#editGridPopup form')[0].reset();
            $('#editGridPopup').data('activeRow', parentTR);
            var data = $(parentTR).data('form');
            setTimeout(() => {
                self.updateValueInElements(data, $('#editGridPopup'));
                window.bindDatePickerIntegrated(false);
            }, 250);
           // TypeaheadUtils.updateTypeAheadData();
            $("#grid-popup-wait").removeClass("d-none");
           TypeaheadUtils.updateDynamicTypeAheadData().then(() => {
               $("#grid-popup-wait").addClass("d-none");
           });
        });
    },

    updateNameInDataByDatafield(newData, form) {
        for (let i = 0; i < newData.length; i++) {
            var ele = $(form).find('[data-datafield][name="' + newData[i].name + '"]');
            newData[i].name = $(ele).attr('data-datafield');
        }
    },
    isChildGrid(tableObj) {
        let activeTR = $(tableObj).closest('.child-grid-row');
        return (activeTR.length > 0);
    },
    getJSONKey(tableObj, mode) {
        let activeTR = $(tableObj).closest('.child-grid-row');
        if (activeTR.length > 0) {
            let activeRow = $('#editGridPopup').data('activeRow');
            let name = $(activeRow).attr('newname');
            if (name == undefined) {
                name = $(tableObj).attr('datasource') + '[0]';
            }
            if (mode == "add") {
                let trCount = $(tableObj).children('tbody').children('tr.form-content-tr').length;
                if (trCount == -1) {
                    trCount = 0;
                }
                name = $(tableObj).attr('datasource') + `[${trCount}]`
            }
            let parentGridTR = $(activeTR).prev('.form-content-tr');
            let parentGridName = $(parentGridTR).attr('newname');
            let parentGridTable = $(parentGridTR).closest('table');
            let parentDS = $(parentGridTable).attr('data-datasource');

            let jsonObjKey = parentGridName + "." + name;
            if (parentDS.indexOf(this.dummyKey) != -1) {
                jsonObjKey = this.dummyKey + "." + jsonObjKey;
            }
            jsonObjKey = this.splitJsonKey(jsonObjKey.split("."));
            return jsonObjKey;
        }
    },
    getDatasource(tableObj) {
        let activeTR = $(tableObj).closest('.child-grid-row');
        if (activeTR.length > 0) {
            let parentGridTR = $(activeTR).prev('.form-content-tr');
            let parentGridTable = $(parentGridTR).closest('table');
            let parentDS = $(parentGridTable).attr('data-datasource');
            return parentDS;
        } else {
            return tableObj.attr("data-datasource");
        }
    },

    hasChildGrid(activeRow) {
        return ($(activeRow).next('.child-grid-row').length > 0)
    },

    getChildGridRow(activeRow) {
        return $(activeRow).next('.child-grid-row');
    },

    saveEditGridIntegrated(e) {
        this.setCollapseStateChildGrids();
        var mode = $('#editGridPopup #mode').attr('value');
        let activeRow = $('#editGridPopup').data('activeRow');
        let tableObj = $(activeRow).closest('table');
        if (tableObj.length == 0) {
            // Empty Grid
            tableObj = $("[data-grid='true']");
            tableObj = $('#editGridPopup').data('activeTable');
        }
        var dataSrc = this.getDatasource(tableObj);
        var currentJsonData = window.dataAsJsonForGrid[dataSrc];
        let form = $('#editGridPopup form');

        if (form != null && !form[0].checkValidity()) {
            e.preventDefault();
            e.stopPropagation();
        } else {
            window.hideDialog('editGridPopup');
            let newData = [];
            window.storeFormDefaultState(newData, form);
            this.updateNameInDataByDatafield(newData, form);
            let arrayData = this.convertToJSONformat(newData);
            let trCount = $(tableObj).children('tbody').children('tr.form-content-tr').length;
            if (mode == 'add') {
                dataSrc = this.splitJsonKey(dataSrc.split("."));
                if (this.isChildGrid(tableObj)) {
                    let jsonObjKey = this.getJSONKey(tableObj, 'add');
                    this.addItemToJsonForGrid(currentJsonData, jsonObjKey, JSON.stringify(arrayData));
                } else if (!this.isChildGrid(tableObj) && this.hasChildGrid(activeRow)) {
                    let childRow = this.getChildGridRow(activeRow);
                    let childTable = $(childRow).find('table');
                    let childDS = $(childTable).attr('datasource');
                    arrayData[childDS] = [];
                    this.addItemToJsonForGrid(currentJsonData, dataSrc
                        + "[" + trCount + "]", JSON.stringify(arrayData));
                } else {
                    dataSrc = this.splitJsonKey(dataSrc.split("."));
                    this.addItemToJsonForGrid(currentJsonData, dataSrc
                        + "[" + trCount + "]", JSON.stringify(arrayData));
                }
            } else {
                let activeIndex = $('#editGridPopup #activeIndex').attr('value');
                let jsonObjKey = $(tableObj).children('tbody').children('tr').eq(activeIndex).attr("newname");
                if (dataSrc.indexOf(this.dummyKey) != -1) {
                    jsonObjKey = this.dummyKey + "." + jsonObjKey;
                }
                jsonObjKey = this.splitJsonKey(jsonObjKey.split("."));
                if (this.isChildGrid(tableObj)) {
                    jsonObjKey = this.getJSONKey(tableObj);
                } else if (this.hasChildGrid(activeRow)) {
                    let childRow = this.getChildGridRow(activeRow);
                    let existingObj = this.getGridObj(currentJsonData, jsonObjKey);
                    let childTable = $(childRow).find('table');
                    let childDS = $(childTable).attr('datasource');
                    arrayData[childDS] = existingObj[childDS];
                }
    
                this.pathForGrid(window.dataAsJsonForGrid[dataSrc], jsonObjKey);
                this.addItemToJsonForGrid(currentJsonData, jsonObjKey, JSON.stringify(arrayData));
            }
            $("div[name='grid-data']").remove();
            let rootGrid = this.isChildGrid(tableObj) ? $(tableObj).closest('[data-grid="true"]') : $(tableObj)
            this.splitDataSourceAndPopulateRowForGrid($(rootGrid), currentJsonData);
            setTimeout(() => {
                this.updateCollapseStateChildGrids();
                window.bindSummaryOperations();
            }, 250);
        }
        $(form).addClass('ms-was-validated');
    },

    // Function to update particular entry from json object
    updatePathForGrid(obj, path, dataFieldName, dataFieldVal) {
        try {
            eval("obj." + path + "." + dataFieldName + "=dataFieldVal");
        } catch (e) {
            return undefined;
        }
    },

    // Function to delete particular entry from json object
    pathForGrid(obj, path) {
        try {
            eval("delete obj." + path);
        } catch (e) {
            return undefined;
        }
    },

    // Function to get particular key from json object
    getGridObj(obj, path) {
        try {
            return eval("obj." + path);
        } catch (e) {
            return undefined;
        }
    },

    // Function to add particular entry in json object
    addPathForGrid(obj, path, index, arrayData) {
        try {
            eval("obj." + path + ".splice(" + index + ",0," + arrayData + ")");
        } catch (e) {
            return undefined;
        }
    },
    updateExistingJsonForGrid(jsonData, dataSrc) {
        var self = this;
        $('[data-grid="true"][data-datasource="' + dataSrc + '"]').each(function (index) {
            var parentName = $(this).attr("newname");

            if (dataSrc.indexOf(self.dummyKey) != -1) {
                parentName = self.dummyKey + "." + parentName;
            }
            $(this).find("[data-datafield]").each(function () {
                var dataFieldName = $(this).attr("data-datafield");
                var dataFieldVal = $(this).val();
                var parentNameTemp = parentName;
                if (parentNameTemp == null || parentNameTemp == "") {
                    parentNameTemp = dataSrc + "[0]";
                }

                self.updatePathForGrid(jsonData, parentNameTemp, dataFieldName, dataFieldVal);
            });
        });
    },

    addItemToJsonForGrid(o, s, arrayData) {
        var originalKey = s;
        s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, ''); // strip a leading dot
        var a = s.split('.');
        originalKey = originalKey.substr(0, originalKey.lastIndexOf("["));
        this.addPathForGrid(o, originalKey, parseInt(a[a.length - 1]) + 1, arrayData);
        return o;
    },

    generateChildRow(dataObj, subGridData, rowIndex, colCount, tableObj) {
        if (subGridData != null) {
            let childGridRow = $('<tr class="child-grid-row"></tr>');
            let tdForChildGrid = $(`<td class="subGridRow d-none" colspan="${colCount}"></td>`);
            window.getPreview(subGridData[0], tdForChildGrid, 0);
            $(childGridRow).append(tdForChildGrid);
            $(tableObj).append(childGridRow);
            $('.subGridDiv').remove();
            let subGridDiv = $('<div class="subGridDiv d-none"></div>');
            $('body').append(subGridDiv);
            let childDatasource = subGridData[0].property.dataSource;
            let renderJSONData = $("#editGridPopup").data('renderJSON')[childDatasource];
            window.getPreview(renderJSONData, subGridDiv, 0);
            setTimeout(() => {
                let eleTrObj = $('<tr class="form-content-tr"></tr>');
                this.addDatafieldAttributeTD($('.subGridDiv'), eleTrObj);
                $(eleTrObj).append($('<div class="formEle d-none"></div>'));
                window.appendFormInTD(renderJSONData, $(eleTrObj).find('.formEle'));
                this.addActionButtonsInTR(eleTrObj)
                let childTable = $(tdForChildGrid).find('table');
                $(childTable).attr("data-datasource", childDatasource);
                ($(childTable).children('tbody')).empty();
                let childObj = dataObj[rowIndex][childDatasource];
                if (childObj != null) {
                    // Generate rows based on json data.
                    for (let i = 0; i < childObj.length; i++) {
                        var newEleObj = $(eleTrObj).clone();
                        ($(childTable).children('tbody')).append(newEleObj);
                    }
                } else {
                    dataObj[rowIndex][childDatasource] = [];
                }
            }, 0);

        }
    },

    addDatafieldAttributeTD(parentDiv, eleTrObj) {
        var colIndex = 0;
        var dataFieldArrObj = []
        // eleTrObj is tr element in which all the td will be appended
        $(parentDiv).find("[data-datafield]").each(function (index) {
            if (!$(this).closest('.form-group').hasClass('d-none')) {
                var field = $(this).attr("data-datafield");
                if (dataFieldArrObj.indexOf(field) == -1) {
                    dataFieldArrObj.push(field);
                    let newTd = $('<td data-datafield="' + field + '"></td>');
                    eleTrObj.append(newTd);
                    $(this).attr("colindex", colIndex);
                    colIndex++;
                }
            }
        });

    },

    addActionButtonsInTR(eleTrObj) {
        let parentOfBtnGrp = $('<td class="action-col"></td>');
        let btnGrpDiv = $('<div class="mcc-button-group"></div>');
        let editBtn = $('<button type="button" class="editBtn mcc-button mcc-button--secondary mcc-button--sm mcc-button--icon-only mu-mr-01"><mcc-icon name="edit" aria-hidden="true"></mcc-icon></button>');
        let copyBtn = $('<button type="button" class="copyBtn mcc-button mcc-button--secondary mcc-button--sm mcc-button--icon-only mu-mr-01"><mcc-icon name="copy" aria-hidden="true"></mcc-icon></button>');
        let deleteBtn = $('<button type="button" class="deleteBtn mcc-button mcc-button--danger mcc-button--sm mcc-button--icon-only"><mcc-icon name="delete" aria-hidden="true"></mcc-icon></button>');
        $(btnGrpDiv).append(editBtn);
        $(btnGrpDiv).append(copyBtn);
        $(btnGrpDiv).append(deleteBtn);
        $(parentOfBtnGrp).append(btnGrpDiv);
        $(eleTrObj).append(parentOfBtnGrp);
    },

    populateRepeatableRowForGrid(originalDataSource, dataSource, dataAsJson, eleObj) {
        var self = this;
        var el = $('<div name="grid-data" class="d-none"></div>');
        $('body').append(el);
        $('.subGridDiv').remove();
        let eleTrObj = $('<tr class="form-content-tr"></tr>')
        var dataFieldArrObj = []
        var dataJSON = $("#editGridPopup").data('renderJSON');
        var colIndex = 0;
        let subGridData = $(eleObj).data("subGridJSON");
        if (subGridData != null) {
            $(eleTrObj).prepend('<td class="grid-collapse"><button type="button" class="mcc-button mcc-button--secondary mcc-button--sm mcc-button--icon-only showGridRow settingsBtn mr-1"><mcc-icon name="angle_right" aria-hidden="true"></mcc-icon></button></td>');
            // colIndex++;
        }
        $("#editGridPopup").find("[data-datafield]").each(function (index) {
             
            if (dataJSON.children && !$(this).hasClass('d-none') && !dataJSON.children[index].property.hidden) {
                var field = $(this).attr("data-datafield");
                if (dataFieldArrObj.indexOf(field) == -1) {
                    dataFieldArrObj.push(field);
                    let newTd = $('<td data-datafield="' + field + '"></td>');
                    eleTrObj.append(newTd);
                    $(this).attr("colindex", colIndex);
                    colIndex++;
                }
            }else{

                let dataSrc = dataJSON[$(eleObj).attr('datasource')];

                if (!$(this).hasClass('d-none') && (dataSrc.children && !dataSrc.children[index]?.property?.hidden)) {
                    var fields = $(this).attr("data-datafield");
                    if (dataFieldArrObj.indexOf(fields) == -1) {
                        dataFieldArrObj.push(fields);
                        let newTd = $('<td data-datafield="' + fields + '"></td>');
                        eleTrObj.append(newTd);
                        $(this).attr("colindex", colIndex);
                        colIndex++;
                    }
                }
            }
             

            
        });

        $(eleTrObj).append($('<div class="formEle d-none"></div>'));
        let ds = $(eleObj).attr('datasource');
        window.appendFormInTD(dataJSON[ds], $(eleTrObj).find('.formEle'));
        this.addActionButtonsInTR($(eleTrObj))

        // Find the data-source
        let obj;
        if (originalDataSource != dataSource) {
            obj = this.recursiveKeySearchForGrid(dataSource, dataAsJson, el);
        } else {
            obj = this.recursiveKeySearchForGrid(dataSource, dataAsJson[originalDataSource], el);
        }

        let newObj = [];
        $("div[remove_this_item]").remove();
        if (originalDataSource != dataSource) {
            window.dataAsJsonForGrid[originalDataSource] = dataAsJson;
        } else {
            window.dataAsJsonForGrid = dataAsJson;
        }
        var isArrayInsideArray = true;

        // Take out array elements\
        for (let i = 0; i < obj.length; i++) {
            if (obj[i].constructor === Array) {
                for (let j = 0; j < obj[i].length; j++) {
                    newObj.push(obj[i][j]);
                }
            }
        }

        if (newObj.length == 0) {
            newObj = obj;
            isArrayInsideArray = false;
        }

        ($(eleObj).find('tbody')).empty();
        // Generate rows based on json data.
        for (let i = 0; i < newObj.length; i++) {
            if (!$.isEmptyObject(newObj[i])) {
                var newEleObj = $(eleTrObj).clone();
                ($(eleObj).children('tbody')).append(newEleObj);
                self.generateChildRow(newObj, subGridData, i, colIndex + 2, $(eleObj));
            }
        }
        $("#typeahead-wait").removeClass("d-none");

        setTimeout(function () {
            self.populateDatafields(originalDataSource, newObj, isArrayInsideArray, eleObj);
            self.addItemIfNoEntryFound(obj, newObj, originalDataSource, dataSource);
            //TypeaheadUtils.updateTypeAheadData();
            TypeaheadUtils.updateDynamicTypeAheadData().then(() => {
                $("#typeahead-wait").addClass("d-none");
            });
        }, 500);
    },

    updateValueInElements(data, selectorString) {
        for (const childData of data) {
            
            let element = $(selectorString).find(`[name='${childData.name}']`);
            let elementType = element.attr('type');
    
            if(elementType == undefined){
                element = $(selectorString).find(`[data-datafield='${childData.name}']`);
                elementType =  element.attr('type');
            }
    
            if (elementType == 'checkbox' || elementType == 'radio') {
                let valArray = childData.value.split(',').map(function (item) {
                    return item.trim();
                });
                element.each(function () {
                    (valArray.indexOf($(this).val()) != -1) ? $(this).prop('checked', true) :
                        $(this).prop('checked', false);
                });
            } else if (element.is('select') && element.attr('multiple') && $(selectorString).find(`[name='${childData.name}']`)[0].slim) {
                if (childData.value != null && childData.value != "") {
                    if (!$.isArray(childData.value)) {
                        childData.value = childData.value.split(",");
                    }
                    $(selectorString).find(`[name='${childData.name}']`)[0].slim.set(childData.value);
                }
            } else {
                $(selectorString).find(`[data-datafield='${childData.name}']`).val(childData.value);
            }
        }
    },

    addItemIfNoEntryFound(obj, newObj, originalDataSource, dataSource) {
        var self = this;
        // No key found in JSON data
        if (obj.length == 0 && newObj.length == 0) {
            if (originalDataSource != dataSource) {
                self.addNewEntryToJsonForGrid(
                    window.dataAsJsonForGrid[originalDataSource], originalDataSource);
            } else {
                self.addNewEntryToJsonForGrid(window.dataAsJsonForGrid, originalDataSource);
            }
        }
    },

    updateFormElementsName(trObj, parentName) {
        $(trObj).find('.formEle').find(".form-control, .form-check-input, .form-select").each(function (index, component) {
            if ($(component).hasClass('datepickerctrl') &&
                $(component).attr('name') == undefined) {
                return;
            }

            if ($(component).hasClass('tt-hint') && $(component).attr('data_ta_src') != undefined) {
                return;
            }

            let datafield = $(component).closest('[data-datafield]').attr('data-datafield');
            let newDatafield = parentName + "." + datafield;
            $(component).closest('[data-datafield]').attr("name", `${newDatafield}`);
            $(component).attr("name", `${newDatafield}`);
            $(component).attr("data-editableGrid-name", datafield);
        });

        // $(trObj).find('.formEle').find("[type='radio'], [type='checkbox']").each(function (index, component) {
        //     let datafield = $(component).closest('[data-datafield]').attr('data-datafield');
        //     let newDatafield = parentName + "." + datafield;
        //     $(component).closest('[data-datafield]').attr("name", `${newDatafield}`);
        //     $(component).attr("name", `${newDatafield}`);
        //     $(component).attr("data-editableGrid-name", datafield);
        // });
    },
    updateDatafieldsInTableRow(rowEle, index, originalDataSource, newObj, isArrayInsideArray, controlContainer) {
        var self = this;
        $(rowEle).attr("newname", self.getNameForGridElements(originalDataSource, index));
        var parentName = $(rowEle).attr("newname");
        var jsonData = {};
        var dataFieldArr = [];
        var formDataNew = [];
        $(rowEle).find("td[data-datafield]").each(function () {
            if ($(rowEle).closest('.child-grid-row').length > 0) {
                parentName = $(rowEle).attr("newname");
                let row = $(rowEle).closest('.child-grid-row');
                let prevRow = $(row).prev('.form-content-tr');
                let prevRowName = $(prevRow).attr('newname');
                parentName = prevRowName + '.' + parentName;
            }
            var dataFieldName = $(this).attr("data-datafield");
            // var dialogControl = $(`#editGridPopup [data-datafield="${dataFieldName}"]`); 
            var dialogControl = $(controlContainer).find(`[data-datafield="${dataFieldName}"]`);
            var controlType = dialogControl.length > 0 ? dialogControl.attr("type") : '';
            var elementData = {
                'name': '', 'value': ''
            }
            $(this).attr("name", parentName + "." + dataFieldName);
            if (dataFieldArr.indexOf(dataFieldName) == -1) {
                dataFieldArr.push(dataFieldName);
            }

            var strArray = dataFieldName.split('.');
            elementData['name'] = dataFieldName;
            if (strArray.length == 1) {
                jsonData[dataFieldName] = "";
            } else {
                var current = jsonData;
                for (var j = 0; j < strArray.length; j++) {
                    if (j == strArray.length - 1) {
                        current[strArray[j]] = ""
                    } else if (!current.hasOwnProperty(strArray[j])) {
                        current[strArray[j]] = {};
                    }
                    current = current[strArray[j]];
                }
            }

            if (isArrayInsideArray) {
                if (strArray.length == 1) {
                    var currentVal = newObj[index]
                        .hasOwnProperty(dataFieldName) ? newObj[index][dataFieldName]
                        : "";

                    if ($(this).attr('type') == "checkbox" || $(this).attr('type') == "radio") {
                        let valArray = currentVal.split(',').map(function (item) {
                            return item.trim();
                        });
                        $(this).each(function () {
                            (valArray.indexOf($(this).val()) != -1) ? $(this).prop('checked', true) :
                                $(this).prop('checked', false);
                        });
                    } else {
                        $(this).val(currentVal);
                        $(this).attr("oldVal", currentVal);
                    }

                    if ($(this).prop('tagName').toLowerCase() == 'td') {
                        var dispFieldVal = (newObj[index]
                            .hasOwnProperty(dataFieldName) ? newObj[index][dataFieldName] : "");
                        if (controlType == "password"
                            && dispFieldVal != null && dispFieldVal != "" && dispFieldVal.trim() != "") {
                            $(this).html(self.passwordMask);
                        } else {
                            $(this).html(dispFieldVal);
                        }
                        elementData['value'] = dispFieldVal;
                    }
                } else {
                    var valToAdd = "";
                    if (newObj[index].hasOwnProperty(strArray[0])) {
                        valToAdd = self.findPropForGrid(newObj[index], dataFieldName);
                    }
                    $(this).val(valToAdd);
                    $(this).attr("oldVal", valToAdd);

                    if ($(this).prop('tagName').toLowerCase() == 'td') {
                        if (controlType == "password"
                            && valToAdd != null && valToAdd != ""
                            && valToAdd.trim() != "") {
                            $(this).html(self.passwordMask);
                        } else {
                            $(this).html(valToAdd);
                        }
                        elementData['value'] = valToAdd;
                    }
                }
            } else {
                $(this).val(newObj[index]);
                $(this).attr("oldVal", newObj[index]);

                if ($(this).prop('tagName').toLowerCase() == 'td') {
                    var fieldVal = newObj[index];
                    if (controlType == "password"
                        && fieldVal != null && fieldVal != "" && fieldVal.trim() != "") {
                        $(this).html(self.passwordMask);
                    } else {
                        $(this).html(fieldVal);
                    }
                    $(this).html(fieldVal);
                }
            }
            formDataNew.push(elementData);
        });
        $(rowEle).attr("data-json", JSON.stringify(jsonData));
        $(rowEle).data("form", formDataNew)
        self.updateValueInElements(formDataNew, $(rowEle).find('.formEle'))
        self.updateFormElementsName($(rowEle), parentName);
    },

    populateDatafields(originalDataSource, newObj, isArrayInsideArray, eleObj) {
        var self = this;
        // Traverse each repeatable row and update name of data field
        $(`[data-grid="true"][data-datasource="${originalDataSource}"]`).children('tbody').children('tr.form-content-tr').each(function (index, rowElement) {
            self.updateDatafieldsInTableRow(rowElement, index, originalDataSource, newObj, isArrayInsideArray, $('#editGridPopup'));
        });

        $(eleObj).children('tbody').children('tr.child-grid-row').each(function (indexTr, rowEle) {
            let childTable = $(rowEle).find('table')
            let dataSource = $(childTable).attr('datasource');
            let childObj = newObj[indexTr][dataSource];
            $(childTable).children('tbody').children('tr.form-content-tr').each(function (index1, rowElement1) {
                self.updateDatafieldsInTableRow(rowElement1, index1, dataSource, childObj, isArrayInsideArray, $('.subGridDiv'));
            });

        });
    },

    addNewEntryToJsonForGrid(jsonData, dataSrcOriginal) {
        var arrayOfDataField = [];
        var ent = {};
        var expenseEntity = {};
        var dataSrc = dataSrcOriginal.split(".");
        $(`[data-grid="true"][data-datasource="${dataSrcOriginal}"]`).each(function (index) {
            $(this).find("[data-datafield]").each(function () {
                var dataFieldName = $(this).attr("data-datafield");
                var strArray = dataFieldName.split('.');
                if (strArray.length == 1) {
                    ent[dataFieldName] = "";
                } else {
                    var current = ent;
                    for (var j = 0; j < strArray.length; j++) {
                        if (j == strArray.length - 1) {
                            current[strArray[j]] = ""
                        } else if (!current.hasOwnProperty(strArray[j])) {
                            current[strArray[j]] = {};
                        }
                        current = current[strArray[j]];
                    }
                }
            });
        });

        if (!$.isEmptyObject(ent)) {
            arrayOfDataField.push(ent);
        } 
        
        var dataSrcName = dataSrc[dataSrc.length - 1];
        expenseEntity[dataSrcName] = arrayOfDataField;

        if (dataSrcOriginal != dataSrcName) {
            jsonData[dataSrc[0]] = expenseEntity;
        } else {
            jsonData[dataSrc[0]] = expenseEntity[dataSrc[0]];
        }
    },

    getNameForGridElements(originalDataSource, index) {
        let dataSourceArr = originalDataSource.split(".");
        let dataSource = dataSourceArr[dataSourceArr.length - 1];
        if (dataSourceArr.length == 1) {
            return originalDataSource + "[" + index + "]";
        }

        var retnString = "";
        if ($("[name='" + dataSourceArr[0] + "']").find(
            "[name='" + dataSource + "']").length > 0
            && $("[name='" + dataSourceArr[0] + "']").find(
                "[name='" + dataSource + "']").length >= index) {
            var eleObj = $("[name='" + dataSourceArr[0] + "']").find(
                "[name=" + dataSource + "]")[index];
            var indexAttr = $(eleObj).attr("personal-index");
            if (typeof indexAttr !== typeof undefined) {
                retnString = dataSource + "[" + indexAttr + "]";
            } else {
                retnString = dataSource;
            }

            while ($(eleObj).parent().length > 0 && $(eleObj).parent().attr('name') != 'grid-data') {
                eleObj = $(eleObj).parent();
                let attr = eleObj.attr('istypearray');
                if (typeof attr !== typeof undefined && attr !== false) {
                    var curName = $(eleObj).attr('name');
                    var items = $('[name="' + curName + '"]');
                    if (eleObj.parent()) {
                        items = eleObj.parent().children('[name="' + curName + '"]');
                    }
                    retnString = eleObj.attr("name") + '[' + items.index($(eleObj))
                        + ']' + '.' + retnString;
                } else {
                    retnString = eleObj.attr("name") + '.' + retnString;
                }
            }
        }

        if (retnString.indexOf(this.dummyKey) != -1) {
            return retnString.replace(this.dummyKey + ".", "");
        } else {
            return retnString;
        }

    },
    findPropForGrid(obj, prop, defval) {
        if (typeof defval == 'undefined')
            defval = null;
        prop = prop.split('.');
        for (var i = 0; i < prop.length; i++) {
            if (typeof obj[prop[i]] == 'undefined')
                return defval;
            obj = obj[prop[i]];
        }
        return obj;
    },

    recursiveKeySearchForGrid(key, data, parentEleObj) {
        // Handle null edge case.
        if (data === null) {
            // nothing to do here
            return [];
        }
        // handle case of non-object, which will not be searched
        if (data !== Object(data)) {
            return [];
        }
        var results = [];
        // Handle array which we just traverse and recurse.
        if (data.constructor === Array) {
            for (var i = 0, len = data.length; i < len; i++) {
                if (data[i] == null) {
                    data.splice(i, 1);
                    if (i != 0) {
                        i--;
                    } else {
                        i = -1;
                    }
                    len = data.length;
                    if (len == 0) {
                        // Remove parentEleObj
                        parentEleObj.attr("remove_this_item", "");
                    }
                } else {
                    if (i != 0) {
                        var name = parentEleObj.attr("name");
                        var el = $('<div name="' + name + '" id="'
                            + this.getNewGUIDStringForGrid() + '">' + name
                            + '</div>');
                        parentEleObj.after(el);
                        parentEleObj = el;
                    }
                    parentEleObj.attr("istypearray", true);
                    parentEleObj.attr("personal-index", i);

                    results = results.concat(this.recursiveKeySearchForGrid(key,
                        data[i], parentEleObj));
                }
            }
            return results;
        }
        // We know we have an general object to work with now.
        // Now we need to iterate keys
        for (var dataKey in data) {
            var el = $('<div name="' + dataKey + '" id="'
                + this.getNewGUIDStringForGrid() + '">' + dataKey + '</div>');
            parentEleObj.append(el);
            if (key === dataKey) {
                el.attr("current-index", parentEleObj.children(
                    "[name=" + dataKey + "]").index(el));
                results.push(data[key]);
            }

            // now recurse into value at key
            results = results.concat(this.recursiveKeySearchForGrid(key,
                data[dataKey], el));
        }
        return results;
    },
    getNewGUIDStringForGrid() {
        let d = new Date().getTime();
        if (window.performance && typeof window.performance.now === "function") {
            d += performance.now(); // use high-precision timer if available
        }
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    },
    createFormData(obj) {
        // Convert key/value to form-data
        let resultingObj = []
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                let newObj = {
                    name: key,
                    value: obj[key]
                }
                resultingObj.push(newObj)
            }
        }
        return resultingObj;
    },
    convertToJSONformat(obj) {
        // Convert form-data to key/value 
        let newObj = {};
        obj.forEach(item => {
            var strArray = item['name'].split('.');
            if (strArray.length == 1) {
                newObj[item['name']] = item['value'];
            } else {
                var current = newObj;
                for (var j = 0; j < strArray.length; j++) {
                    if (j == strArray.length - 1) {
                        current[strArray[j]] = item['value']
                    } else if (!current.hasOwnProperty(strArray[j])) {
                        current[strArray[j]] = {};
                    }
                    current = current[strArray[j]];
                }
            }
        });
        return newObj;
    }
}

export default Grid_Utils;